/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ClearanceCaseCustomerStatus {
  Cancelled = -1,
  Created = 0,
  Registered = 1,
  Processing = 2,
  Waiting = 3,
  Completed = 4,
}
